import React from "react";
import styled from "styled-components";

const Description = ({ title, copy, image, layout, link }) => {
  console.log(layout);
  const photo = <Image src={image} />;
  const description = (
    <>
      <Title>{title}</Title>
      <Copy>{copy}</Copy>
      <Link target="_blank" href={link}>
        Link
      </Link>
    </>
  );
  return (
    <Box>
      <Left>{layout === "left" ? photo : description}</Left>
      <Right>{layout == "right" ? photo : description}</Right>
    </Box>
  );
};

const Box = styled.div`
  margin: 1em auto 3em;
  box-shadow: 7px 4px 12px 1px rgba(0, 0, 0, 0.52);
  border-radius: 2px;
  padding: 1em;
  max-width: 840px;
  text-align: left;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    font-size: 2em;
    font-weight: bolder;
  }
`;
const Left = styled.div`
  width: 400px;
  vertical-align: top;
  height: 100%;
`;
const Right = styled.div`
  width: 400px;
  vertical-align: top;
  height: 100%;
`;
const Title = styled.h3``;
const Image = styled.img`
  width: 400px;
  box-shadow: 4px 7px 8px grey;
  border-radius: 2px;
`;
const Credit = styled.span``;
const Copy = styled.p``;
const Link = styled.a``;
export default Description;
